// TenantCompanyMenus.jsx — 테넌트 관리자용 '회사별 메뉴' (2026-10-19)
//   테넌트 관리 화면은 운영자 전용이라, 테넌트 관리자는 지금처럼 업무/기능 배정 › 고객사 기능 배정에서 자기 테넌트 회사 메뉴를 정한다.
//   화면 부품은 테넌트 관리 › 회사 탭과 같은 CompanyMenuPanel 하나(주소·검사 같음 — 자기 테넌트·테넌트가 받은 메뉴 안에서만).
//   report = 서버가 준 회사 모듈 보고(rows: company_code·company_name·is_primary …).
import React, { useMemo } from 'react';
import { useToast } from '../../../components/Toast';
import CompanyMenuPanel from './CompanyMenuPanel';

export default function TenantCompanyMenus({ report }) {
  const { showToast } = useToast();
  const tenantCode = report?.tenantCode;
  const companies = useMemo(() => {
    const map = new Map();
    for (const r of report?.rows || []) {
      const code = String(r.company_code || '').toUpperCase();
      if (code && !map.has(code)) map.set(code, { code, name: r.company_name || code, is_primary: r.is_primary === true });
    }
    // 대표 회사 먼저
    return [...map.values()].sort((a, b) => Number(b.is_primary) - Number(a.is_primary) || a.code.localeCompare(b.code));
  }, [report]);

  if (!tenantCode || companies.length === 0) return null;
  return (
    <section style={{ border: '1px solid var(--border)', borderRadius: 8, background: 'var(--bg-card)', padding: 12, display: 'grid', gap: 12 }}>
      <div>
        <div style={{ fontSize: 14, fontWeight: 900 }}>회사별 메뉴</div>
        <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 2 }}>운영사가 우리 테넌트에 준 메뉴 안에서, 회사마다 줄 메뉴를 정합니다.</div>
      </div>
      {companies.map((c) => (
        <div key={c.code} style={{ borderTop: '1px dashed var(--border)', paddingTop: 10 }}>
          <div style={{ fontSize: 13, fontWeight: 800, marginBottom: 6 }}>{c.name}{c.is_primary ? ' (대표)' : ''}</div>
          <CompanyMenuPanel tenantCode={tenantCode} company={c} showToast={showToast} forTenantAdmin />
        </div>
      ))}
    </section>
  );
}
